import {atom} from "jotai";


export const atomFavouriteInfo = atom(false);
